import DatePicker from "react-datepicker";
import React, { FC, useState, useEffect } from "react";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import { useClient } from "ClientContext";

//transalation
import { useTranslation } from "react-i18next";

export interface StayDatesRangeInputProps {
  className?: string;
}

const TODAY = new Date();

const StayDatesRangeInput: FC<StayDatesRangeInputProps> = ({
  className = "",
}) => {
  const {t} = useTranslation();
  const { global_searh, setGlobal_search } = useClient();
  const { checkIn, checkOut, guestsCount, location } = global_searh.params;
  const [startDate, setStartDate] = useState<Date | null>(checkIn);
  const [endDate, setEndDate] = useState<Date | null>(checkOut);

  // Sync with searchParams if they are updated externally
  useEffect(() => {
    if (checkIn) setStartDate(checkIn);
    if (checkOut) setEndDate(checkOut);
  }, [global_searh.params]);

  // Handle date selection
  const onChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    if (startDate !== start || endDate !== end) {
      setStartDate(start);
      setEndDate(end);
      setGlobal_search((prevState) => ({
        ...prevState,
        params: {
          ...prevState.params,
          checkIn: start, // Update with the new start date
          checkOut: end,  // Update with the new end date
        },
      }));
    }
  };

  // Handle clearing dates
  const clearDates = () => {
    setStartDate(null);
    setEndDate(null);
    setGlobal_search((prevState) => ({
      ...prevState,
      params: {
        ...prevState.params,
        checkIn: null,
        checkOut: null,
      },
    }));
  };

  return (
    <div>
      <div className="p-5">
        <span className="block font-semibold text-xl sm:text-2xl">
        {t("When's your trip?")}
        </span>
        {startDate || endDate ? (
          <button
            className="text-sm text-primary-500 hover:underline ml-2"
            onClick={clearDates}
          >
            {t("Clear dates")}
          </button>
        ) : null}
      </div>
      <div
        className={`relative flex-shrink-0 flex justify-center z-10 py-5 ${className}`}
      >
        <DatePicker
          minDate={TODAY}
          selected={startDate}
          onChange={onChangeDate}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          monthsShown={2}
          showPopperArrow={false}
          inline
          renderCustomHeader={(p) => (
            <DatePickerCustomHeaderTwoMonth {...p} />
          )}
          renderDayContents={(day, date) => (
            <DatePickerCustomDay dayOfMonth={day} date={date} />
          )}
        />
      </div>
    </div>
  );
};

export default StayDatesRangeInput;